// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { getVisaTimeColor } from "../theme/status-colors";
import { countries } from "./const";
import Tooltip from '@mui/material/Tooltip';


function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function getDateForDB(date) {
  if (isValidDate(date)) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1; //Starts from 0
    var day = date.getDate();
    return (
      year +
      "-" +
      (month < 10 ? "0" + month : month) +
      "-" +
      (day < 10 ? "0" + day : day)
    );
  }
}

export function getDateWithNoTimezone(date) {
  var dbDate = getDateForDB(date);
  var dateWithNoTimezone = new Date(dbDate + "T00:00:00");
  return isValidDate(dateWithNoTimezone) ? dateWithNoTimezone : null;
}


export function getGmailMailTo(email, subject) {
  var urlToReturn =
    "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=" + email;
  if (subject) {
    urlToReturn += "&su=" + subject;
  }
  return urlToReturn;
}

export function adjustForTimezone(date) {
  var timeOffsetInMS = date.getTimezoneOffset() * 60000;
  date.setTime(date.getTime() - timeOffsetInMS);
  return date;
}

export function getCountryNameFromCountryCode(code) {
  if (!code) return ""
  let countryFilter = countries.filter(country => country[0] === code)
  if (countryFilter.length === 0) return code
  let countryArray = countryFilter[0] ? countryFilter[0] : code
  let countryName = countryArray[1] ? countryArray[1] : code
  return countryName
}

export function getCountryCodeFromCountryName(name) {
  if (!name) return ""
  let countryFilter = countries.filter(country => country[1] === name)
  if (countryFilter.length === 0) return name
  let countryArray = countryFilter[0] ? countryFilter[0] : name
  let countryCode = countryArray[0] ? countryArray[0] : name

  return countryCode
}

// function to calculate day different
export function dayDifferent(date1, date2) {
  var milSecsForOneDay = 1000 * 60 * 60 * 24;
  return Math.ceil((date1.getTime() - date2.getTime()) / milSecsForOneDay);
}

export function getTimeLabelAndColor(date1, date2) {
  var one_day = 1000 * 60 * 60 * 24;
  let numberOfDays = Math.ceil((date1.getTime() - date2.getTime()) / one_day);
  var years = Math.floor(numberOfDays / 365);
  var months = Math.floor(numberOfDays % 365 / 30);
  var days = Math.floor(numberOfDays % 365 % 30);
  if (years > 0) {
    if (years === 1) return [years + " yr", getVisaTimeColor(years, months, days)]
    return [years + " yrs", getVisaTimeColor(years, months, days)]
  }
  if (months > 0) {
    if (months === 1) return [months + " mo", getVisaTimeColor(years, months, days)]
    return [months + " mos", getVisaTimeColor(years, months, days)]
  }
  if (days >= 0) {
    if (days === 1) return [days + " d", getVisaTimeColor(years, months, days)]
    return [days + " d", getVisaTimeColor(years, months, days)]
  }
  return [numberOfDays + "d", getVisaTimeColor(years, months, numberOfDays)]
}

export function getCountryList() {
  let countryList = []
  countries.map(country => {
    let countryObject = { country: country[1], countryCode: country[0] }
    countryList.push(countryObject)
  })
  return countryList;
}

export function truncateString(str, n) {
  if (str && str.length > n) {
      return <Tooltip title={str}>
          <span>{str.substr(0, n - 1) + '...'}</span>
      </Tooltip>
  }
  else {
      return <span>{str}</span>
  }
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
      return -1;
  }
  if (b[orderBy] > a[orderBy]) {
      return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
          return order;
      }
      return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function imageContentToImage(imageData) {
  var binary = '';
  var bytes = new Uint8Array(imageData);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary
}

export function generatePerdiemPaymentNumber(jobNumber, currentCount) {
  const sequenceNumber = currentCount + 1;
  const sequenceNumberPadded = `000${sequenceNumber}`.slice(-3);
  return `${jobNumber}-${sequenceNumberPadded}`;
};

export function formatDate(date) {
  const formattedDate = new Date(date);
  return formattedDate.toISOString().split('T')[0]; 
};

export function formatAmount(value) {
  if (value == null) return "-";
  return new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
}

export function escapeCsv(value) {
  if (value === null || value === undefined) value = "";
  value = String(value);
  if (/^[=+\-@]/.test(value)) {
    value = "'" + value;
  }
  if (value.includes('"')) {
    value = value.replace(/"/g, '""');
  }
  if (/[",\n\r]/.test(value)) {
    value = `"${value}"`;
  }
  return value;
}
